/* eslint-disable no-unused-vars*/
import React from 'react';
import { Form, Input, Row, Col, Tooltip, Space, Select } from 'antd';
import { SearchOutlined, SyncOutlined } from '@ant-design/icons';
import { ButtonDelete, ButtonPrimary } from 'common/Button/Button.styles';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import Color from 'constants/color';
const { Option } = Select;

const SearchAutomaticallyLimitnumber = (props: any) => {
   const { handleReset, dataSearch } = props;
   const isMobileView = useSelector((state) => get(state, 'device.isMobileView', false));

   const renderOption = () => {
      if(dataSearch?.length > 0){
         return dataSearch?.map((value: any ,index: number) => {
            return (
               <Option value={value.id} key={index}>{value.lottery_type_name}</Option>
            )
         })
      }
   }

   return (
      <Row justify={isMobileView ? 'start' : 'end'} gutter={16}>
         <Col span={isMobileView ? 8 : 6}>
            <Form.Item
               name="lottery_type_id"
               // label="ประเภทหวย"
               style={{ width: isMobileView ? '120px' : ''}}
            >
               <Select placeholder="กรุณาเลือก ประเภทหวย"
                  // onChange={(e, option: any) => setGroupUser(option?.children)}
               >
                  {renderOption()}
               </Select>
            </Form.Item>
         </Col>
         <Col span={isMobileView ? 8 : 6}>
            <Form.Item
               name="search"
            >
               <Input style={{ width:  isMobileView ? '120px' : ''}} size='large' type="text" prefix={<SearchOutlined className="site-form-item-icon" style={{ color: Color.darkGray }} />} placeholder="ค้นหาข้อมูล" />
            </Form.Item>
         </Col>
         <Col style={{ alignItems: isMobileView ? 'start' : 'flex-end' }} >
            <Space size={8}>
               <Tooltip title="ค้นหาข้อมูล">
                  <ButtonPrimary
                     htmlType="submit"
                     key="search"
                     // size='large'
                     style={{ height: '37px' }}
                  >
                     <SearchOutlined />
                  </ButtonPrimary>
               </Tooltip>
               <Tooltip title="รีเซ็ต">
                  <ButtonDelete
                     onClick={handleReset}
                     key="reset"
                     // size='large'
                     style={{ height: '37px' }}
                  >
                     <SyncOutlined />
                  </ButtonDelete>
               </Tooltip>
            </Space>
         </Col>
      </Row>
   );
};
export default SearchAutomaticallyLimitnumber;
